import React from 'react';
import { ArrowDown, ArrowUp, ArrowCounterClockwise } from 'phosphor-react';
import { Button } from '@/components/ui/button';

export const OptionsAnalyticsModuleOrderEditor = ({ modules, onMoveUp, onMoveDown, onReset, t }) => {
  return (
    <div className="space-y-3 rounded-[24px] border border-white/10 bg-white/[0.03] p-4" data-testid="options-analytics-module-order-editor">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-white/75" data-testid="options-analytics-module-order-editor-title">{t('analytics.editOrder')}</p>
          <p className="mt-1 text-sm text-white/50" data-testid="options-analytics-module-order-editor-helper">{t('analytics.editOrderHelper')}</p>
        </div>

        <Button variant="outline" size="sm" onClick={onReset} data-testid="options-analytics-module-order-reset-button">
          <ArrowCounterClockwise size={14} className="mr-2" />
          {t('analytics.resetOrder')}
        </Button>
      </div>

      <div className="space-y-2" data-testid="options-analytics-module-order-editor-list">
        {modules.map((module, index) => (
          <div key={module.id} className="flex items-center justify-between gap-3 rounded-2xl border border-white/10 bg-black/20 px-3 py-3" data-testid={`options-analytics-module-order-row-${module.id}`}>
            <div className="min-w-0">
              <p className="text-sm font-semibold text-white" data-testid={`options-analytics-module-order-row-${module.id}-title`}>{module.title}</p>
              <p className="mt-1 text-xs text-white/48" data-testid={`options-analytics-module-order-row-${module.id}-description`}>{module.summary}</p>
            </div>

            <div className="flex items-center gap-2">
              <Button variant="outline" size="icon" onClick={() => onMoveUp(module.id)} disabled={index === 0} data-testid={`options-analytics-module-order-row-${module.id}-up`}>
                <ArrowUp size={14} />
              </Button>
              <Button variant="outline" size="icon" onClick={() => onMoveDown(module.id)} disabled={index === modules.length - 1} data-testid={`options-analytics-module-order-row-${module.id}-down`}>
                <ArrowDown size={14} />
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OptionsAnalyticsModuleOrderEditor;